<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <router-link to="/cdn">cdn项目管理</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>连接管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索 -->
    <div class="content">
      <el-form
        inline
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        @submit.native.prevent="getList()"
      >
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList()">查询</el-button>
          <el-button
            type="success"
            @click="
              dialogVisible = true;
              form = {};
            "
            >新增</el-button
          >
        </el-form-item>
      </el-form>

      <!-- 主体 -->
      <el-card class="box-card table">
        <div
          class="clearfix"
          slot="header"
          style="font-weight: 700; text-align: center"
        >
          <span>{{ info.name }}</span>
        </div>
        <div class="title">{{ info.summary }}</div>
        <div class="activity" style="text-align: center">
          <a :href="info.gitUrl" target="_blank" v-if="info.gitUrl">源码地址</a>
          <a
            :href="info.siteUrl"
            target="_blank"
            v-if="info.siteUrl && info.gitUrl"
            >实例演示</a
          >
        </div>

        <el-card class="box-card table">
          <el-timeline>
            <el-timeline-item
              v-for="item in tableData"
              :value="item.id"
              :label="item.proName"
              :key="item.id"
              color="#60DB94"
            >
              <div class="version">
                <div class="left">版本：{{ item.version }}</div>
                <div class="right">
                  <el-button
                    type="danger"
                    size="mini"
                    icon="el-icon-close"
                    @click="delClick(item.id)"
                  ></el-button>
                  <el-button
                    class="tagall"
                    type="warning"
                    size="mini"
                    @click="copyAllLabel(item)"
                    >全复制</el-button
                  >
                </div>
                <div class="clear"></div>
              </div>
              <div
                class="introduction"
                v-for="item in item.urlContent.split('\n')"
                :value="item"
                :label="item"
                :key="item"
              >
                <div class="right">
                  <el-button
                    type="success"
                    size="mini"
                    v-clipboard:copy="item"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                    >复制链接</el-button
                  >
                  <el-button
                    class="tag"
                    type="warning"
                    size="mini"
                    @click="copyLabel(item)"
                    >复制标签</el-button
                  >
                </div>
                <div class="introl">{{ item }}</div>
              </div>
            </el-timeline-item>
          </el-timeline>
          <div class="blank" v-if="tableData.length == 0">暂无数据~~</div>
        </el-card>
      </el-card>
    </div>

    <!-- 操作对话框 -->
    <el-dialog
      :title="form.id > 0 ? '编辑链接信息' : '添加链接信息'"
      :visible.sync="dialogVisible"
    >
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm('form')"
      >
        <el-form-item
          label="链接"
          prop="urlContent"
          :rules="[{ required: true, message: '不能为空' }]"
        >
          <el-input
            type="textarea"
            v-model="form.urlContent"
            placeholder="请输入链接内容，使用换行隔开"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="版本号"
          prop="version"
          :rules="[{ required: true, message: '不能为空' }]"
        >
          <el-input
            v-model="form.version"
            placeholder="请输入版本号"
          ></el-input>
        </el-form-item>
        <el-form-item class="dialog-footer">
          <el-button type="primary" :loading="submiting" native-type="submit"
            >提交</el-button
          >
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import Clipboard from "clipboard";
export default {
  data() {
    return {
      linkid: "",
      query: {},
      form: {},
      dialogVisible: false,
      dialogVersion: false,
      loading: false,
      submiting: false,
      tableData: [],
      total: 0,
      currentPage4: 1,
      pageSize: 10,
      verslist: [],
      prolist: [],
      info: {},
    };
  },
  methods: {
    // 项目
    getProList: function () {
      var _this = this;
      var key = _this.query.key;
      var link = url.getCdn("getproject");
      $.get(link, { key: key }, (data) => {
        _this.prolist = data;
      });
    },
    // 获取对象
    getModel: function () {
      var _this = this;
      var proid = _this.linkid;
      var link = url.getCdn("getmodel_project");
      $.get(link, { proid: proid }, (data) => {
        _this.info = data;
      });
    },
    //   列表
    getList: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.proid = _this.linkid;
      var link = url.getCdn("getversion");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = data;
      });
    },
    // 查询
    selList: function () {
      this.getList();
    },
    // 编辑
    editClick: function (row) {},
    // 删除
    delClick: function (id) {
      var _this = this;
      var link = url.getCdn("deleteversion");
      var id = id;

      this.$confirm("确定要删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          $.post(link, { id: id }, (res) => {
            _this.loading = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 复制链接
    onCopy() {
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    onError() {
      this.$message.error("复制失败");
    },
    // 复制标签
    copyLabel: function (row) {
      var link = null;
      if (row.match(/js$/)) {
        link = '<script src="' + row + '"><' + "/script>";
      } else if (row.match(/css$/)) {
        link = "<link href='" + row + "'  rel='stylesheet' />";
      }
      let clipboard = new Clipboard(".tag", {
        text: function () {
          return link;
        },
      });
      clipboard.on("success", (e) => {
        this.$message({
          message: "复制成功",
          showClose: true,
          type: "success",
        });
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        this.$message({ message: "复制失败,", showClose: true, type: "error" });
        clipboard.destroy();
      });
    },
      // 全复制
    copyAllLabel: function (row) {
      var _this = this;
      var array = row.urlContent.split("\n");
      var link='';
      for (var i = 0; i < array.length; i++) {
        var item = array[i];
        if (item.match(/js$/)) {
          link +='<script src="' + item + '"><' + "/script>";
        } else if (item.match(/css$/)) {
          link +='<link href="' + item + '"  rel="stylesheet" />';
        }
        link+='\n';
      }
        let clipboard = new Clipboard(".tagall", {
          text: function () {
            return link;
          },
        });
        clipboard.on("success", (e) => {
          this.$message({
            message: "复制成功",
            showClose: true,
            type: "success",
          });
          // 释放内存
          clipboard.destroy();
        });
        clipboard.on("error", (e) => {
          this.$message({
            message: "复制失败,",
            showClose: true,
            type: "error",
          });
          clipboard.destroy();
        });
    },
    // 提交
    submitForm: function (formName) {
      var _this = this;
      var link = url.getCdn("addversion");
      var info = this.form;
      info.proID = _this.linkid;

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true;

          // 提交后台  添加或修改
          $.post(link, info, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
    var _this = this;
    //   接收参数
    _this.linkid = this.$route.query.id;
    if (this.linkid > 0) {
      this.getList();
    } else {
      _this.form = {};
    }
    // 获取对象
    _this.getModel();
    // 项目
    _this.getProList();
  },
};
</script>

<style scoped>
.box-card .title {
  padding-bottom: 20px;
}
</style>